import Layout from "components/homeComponent/Layout";
import BlogPage from "pages/BlogPage";
import HomePage from "pages/Home/HomePage";
import SarafiPage from "pages/SarafiPage";
import TakArz from "pages/TakArz";
import Profile from "pages/Profile";
import Edit from "components/profile/Edit";
import { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import WithAuthenticationContext from "Authentication/AuthenticationContext.ts";
import { TwitteContextProvider } from "./context/twitteContext";
import MatlabPage from "pages/MatlabPage";
import { useEffect, useState } from "react";
import { sendRequestAPIMain } from "hooks/useAxios";
import { sendRepeatedRequest } from "utils/helperFunctions";

function App() {
  // useEffect(() => {
  //   sendRequest("hi", {});
  // }, []);
  const [priceList, setPriceList] = useState({});
  const [USDTPrice, setUSDTPrice] = useState(0);
  useEffect(() => {
    sendRequestAPIMain("get_price_list", {}).then(({ data }) => {
      let temp = data.data;
      setUSDTPrice(temp.usdt_price);
      delete temp.usdt_price;
      setPriceList(temp);
    });
    sendRepeatedRequest();
  }, []);

  const auth = useContext(WithAuthenticationContext);
  return (
    <div className="App">
      <WithAuthentication>
        <TwitteContextProvider>
          <Layout>
            <Routes>
              <Route path="/sarafi" element={<SarafiPage />} />
              <Route path="/crypto/:query" element={<TakArz />} />
              <Route
                path="/exchange/:exchangeName"
                element={
                  <SarafiPage priceList={priceList} USDTPrice={USDTPrice} />
                }
              />
              <Route path="/arz" element={<TakArz />} />
              <Route path="/edit" element={<Edit />} />
              <Route path="/matlab" element={<MatlabPage />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route
                path="/"
                element={
                  <HomePage
                    priceList={Object.values(priceList)}
                    USDTPrice={USDTPrice}
                  />
                }
              />
            </Routes>
          </Layout>
        </TwitteContextProvider>
      </WithAuthentication>
    </div>
  );
}

export default App;
